// Lightweight prefill helper for opening chat with a pre-inserted mention

declare global {
  interface Window {
    __cadenceChatPrefill?: {
      type: string;
      id: string;
      name: string;
      customPrompt?: string;
      fullPrompt?: string;
    } | null;
  }
}

export type ChatPrefill = {
  type: string;
  id: string;
  name: string;
  customPrompt?: string;
  fullPrompt?: string;
};

export const setChatPrefill = (prefill: ChatPrefill) => {
  try {
    window.__cadenceChatPrefill = prefill;
    // Fire an optional event for listeners
    const evt = new CustomEvent('cadence:chat-prefill', { detail: prefill });
    window.dispatchEvent(evt);
  } catch (_) {
    // no-op
  }
};

export const consumeChatPrefill = (): ChatPrefill | null => {
  try {
    const current = window.__cadenceChatPrefill || null;
    window.__cadenceChatPrefill = null;
    return current;
  } catch (_) {
    return null;
  }
};


